import React from 'react';
import { Brain, History, Loader2 } from 'lucide-react';
import ShareButtons from '../ShareButtons';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Badge } from '../ui/badge';

export const PredictionHistoryList = ({ history, lotteries, loadingHistory }) => (
  <Card className="glass-card" data-testid="prediction-history">
    <CardHeader>
      <CardTitle className="text-white flex items-center gap-2">
        <History size={20} className="text-purple-400" />
        Historial de Predicciones
      </CardTitle>
      <CardDescription className="text-slate-400">
        Tus ultimas predicciones generadas con Sócrates
      </CardDescription>
    </CardHeader>
    <CardContent>
      {loadingHistory ? (
        <div className="text-center py-8">
          <Loader2 size={32} className="mx-auto text-purple-400 animate-spin" />
        </div>
      ) : history.length > 0 ? (
        <div className="space-y-3">
          {history.map((pred) => {
            const lottery = lotteries.find(l => l.id === pred.lottery_id);
            return (
              <div
                key={pred.id || pred.lottery_id}
                className="p-4 rounded-lg bg-slate-900/50 border border-slate-800 hover:border-purple-500/30 transition-colors"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: lottery?.color || '#8b5cf6' }}>
                      <Brain size={18} className="text-white" />
                    </div>
                    <div>
                      <p className="text-white font-medium">{lottery?.name || 'Loteria'}</p>
                      <p className="text-slate-500 text-xs">
                        {new Date(pred.created_at).toLocaleDateString('es-DO', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="flex gap-2">
                      {pred.numbers?.map((num, i) => (
                        <span key={`hist-num-${num}-${i}`} className="w-8 h-8 rounded-full bg-purple-500/20 flex items-center justify-center text-purple-300 font-mono text-sm font-bold">
                          {String(num).padStart(2, '0')}
                        </span>
                      ))}
                    </div>
                    <Badge variant="outline" className="text-green-400 border-green-500/30">{pred.confidence}%</Badge>
                  </div>
                </div>
                <div className="mt-3 pt-3 border-t border-slate-800/50">
                  <ShareButtons prediction={{ numbers: pred.numbers, confidence: pred.confidence }} lotteryName={lottery?.name || 'Loteria'} variant="icons-only" className="justify-end" />
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center py-8">
          <Brain size={48} className="mx-auto text-slate-600 mb-3" />
          <p className="text-slate-400">No hay predicciones todavia</p>
          <p className="text-slate-500 text-sm">Genera tu primera prediccion con Sócrates</p>
        </div>
      )}
    </CardContent>
  </Card>
);
